import { Modal } from "antd";

export default function ModalAntd({ isOpen, showFooter, closeIcon, width, styles, title, children, closable, className }) {

    return (
        <Modal
            title={title}
            closeIcon={closeIcon}
            open={isOpen}
            width={width}
            footer={showFooter}
            styles={styles}
            closable={closable}
            children={children}
            className={className}
        />
    );
}